<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :description="$t('analytics.insights.recruitment_process.interviewed_candidates.description').toString()"
            :title="$t('analytics.insights.recruitment_process.interviewed_candidates.title').toString()"
            icon="pie-chart"
        />
        <div class="w-full">
            <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
                <loading color="blue" size="small"/>
            </div>
            <div v-else>
                <div v-if="!!seriesDataLength" class="h-240">
                    <div class="h-full relative">
                        <apexchart
                            id="interviewedCandidates"
                            ref="interviewedCandidates"
                            :options="chartOptions"
                            :series="series"
                            height="100%"
                            width="100%"
                        />
                    </div>
                </div>
                <div v-else class="flex flex-col px-10">
                        <span class="text-center italic my-16">
                            {{ $t('analytics.empty_series') }}
                        </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as analytics from "../../services/AnalyticsService";
import analyticsMixins from "../../mixins/analyticsMixins";
import VueApexCharts from 'vue-apexcharts';
import chartOptions from '../../config/apex-charts';
import GraphTitle from "./GraphTitle.vue";
import Loading from "../ui/Loading.vue";
import Moment from "moment";
import {extendMoment} from "moment-range";

const moment = extendMoment(Moment);

export default {
    name: "InterviewedCandidates",
    components: {
        'apexchart': VueApexCharts,
        Loading,
        GraphTitle
    },
    mixins: [analyticsMixins],
    props: {
        filterFields: {type: Object},
    },
    computed: {
        chartOptions() {
            return {
                ...chartOptions,
                chart: {
                    ...chartOptions.chart,
                    type: 'donut',
                    toolbar: {
                        ...chartOptions.chart.toolbar,
                        show: true,
                    }
                },
                colors: ['#008FFB', '#D6D9E4'],
                labels: [
                    this.$t('analytics.insights.recruitment_process.interviewed_candidates.interviewed'),
                    this.$t('analytics.insights.recruitment_process.interviewed_candidates.uninterviewed')
                ],
                plotOptions: {
                    pie: {
                        donut: {
                            size: '85%',
                            labels: {
                                show: true,
                                name: {
                                    show: false,
                                },
                                total: {
                                    show: true,
                                    showAlways: true,
                                    formatter(w) {
                                        return w.globals.series[0] + '%';
                                    },
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    ...chartOptions.legend,
                    position: 'right',
                    markers: {
                        ...chartOptions.legend.markers,
                        offsetX: -2,
                    }
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none',
                        }
                    },
                },
                tooltip: {
                    custom: function({series, seriesIndex, dataPointIndex, w}) {
                        return (
                            '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex; background-color: ' + w.globals.fill.colors[seriesIndex] + '">' +
                                '<div class="apexcharts-tooltip-text" style="font-family: Inter, sans-serif; font-size: 12px;">' +
                                    '<div class="apexcharts-tooltip-y-group">' +
                                        '<span class="apexcharts-tooltip-text-y-label">' + w.globals.labels[seriesIndex] + ': ' + '</span>' +
                                        '<span class="apexcharts-tooltip-text-y-value">' + series[seriesIndex] + '%</span>' +
                                    '</div>' +
                                '</div>' +
                            '</div>'
                        )
                    }
                }
            };
        },
        seriesDataLength() {
            return this.series.length;
        },
    },
    methods: {
        async fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }

            return await analytics.interviewedCandidates(this.filterFields).then(response => {
                    this.graphData = response;
                }).then(() => this.buildChart())

        },
        buildChart() {
            this.series = JSON.parse(JSON.stringify(this.graphData.data))
            this.fetching = false;
            this.$nextTick(() => {
                this.graphRef = this.$refs.interviewedCandidates;
                this.setDownloadButtonId(this.graphRef, 'downloadChartInterviewedCandidates');
            })
        },
    },
    mounted() {
        this.$nextTick(() => {
            chartOptions.chart.events = {
                mounted: function () {
                    self.loading = false;
                }
            }
        });
    }
}
</script>
<style>
#interviewedCandidates .apexcharts-legend {
    justify-content: center !important;
    top: 0 !important;
}
</style>
